/**
 * Created by varunsharma on 24/01/18.
 */
angular.module('myApp.orderHistory', ['ngRoute'])

    .config(['$routeProvider', function($routeProvider) {
        $routeProvider.when('/order-history', {
            templateUrl: 'components/orderHistory/orderHistory.html',
            controller:'orderHistoryCtrl'
        })
        $routeProvider.when('/order-history/:product_type/:order_id', {
            templateUrl: 'components/orderHistory/status.html',
            controller:'orderStatusCtrl'
        });

    }])

    .filter('paymentMode', function() {
        return function(val) {
            switch (val) {
                case 1:
                    return 'CASH';
                    break;
                case 2:
                    return 'PAYTM';
                    break;
                case 3:
                    return 'MOBIKWIK';
                    break;
                case 4 :
                    return 'FREECHARGE';
                case 5 :
                    return 'JUGNOO PAY';
                    break;
                case 6:
                    return 'RAZOR PAY';
                    break;
                case 786:
                    return 'UPI RAZOR PAY';
                    break;
                case 7 :
                    return 'ICICI UPI';
                    break;
            }
        };
    })

    .controller('orderHistoryCtrl', ['$http','$timeout','$scope', '$window','$location','API','$rootScope','$document',function($http,$timeout, $scope, $window, $location, API, $rootScope,$document) {
        $window.scrollTo(0,0);
        $scope.paginationLoader = false;


            $scope.getOrderHistory =function(page) {

                $rootScope.loading_custom = true;





                API.post(rides_baseUrl2 + "autos_integrated_order_history", {
                    access_token: localStorage.getItem('accessToken'),
                    start_from : page ,
                    offering_array: ["rides","fatafat"]


                }).then(function (result) {
                    if(result.data.flag==173)
                    {
                        $scope.orderHistory = result.data.data;
                        $scope.size = result.data.history_size;
                        $rootScope.loading_custom = false;
                    }
                   console.log(result)
                });
            }
            $scope.orderPage= function(order) {

                if(order.product_type != 1) {
                    $location.path('/order-history/' + order.product_type + '/' + order.order_id);
                }
                else if(order.product_type == 1) {
                    $location.path('/order-history/' + order.product_type + '/' +  order.engagement_id);
                }



            }
           var i =10;


            $scope.showMore =function ()

            {
                $scope.paginationLoader = true;


                $timeout(function () {

                    API.post(rides_baseUrl2+"autos_integrated_order_history", {
                        access_token: localStorage.getItem('accessToken'),
                        start_from : i ,
                        offering_array: ["rides","fatafat"]


                    }).then(function (result) {
                        if(result.data.flag==173)
                        {
                            $scope.orderHistory = $scope.orderHistory.concat(result.data.data);
                            i=i+10;
                            $scope.paginationLoader = false;

                        }

                    });

                })


            }

        $scope.$on('$destroy', function() {
            $document.unbind('scroll');
        });




        $scope.getOrderHistory(0);

    }]).controller('orderStatusCtrl', ['$scope', '$mdDialog', '$rootScope', '$window', '$timeout', '$location', 'API', '$routeParams','$interval',
    function($scope, $mdDialog, $rootScope, $window, $timeout, $location, API, $routeParams,$interval) {


        $window.scrollTo(0,0);

        $scope.startConversation = function() {

            a = {
                "custom_label" : $scope.orderDetails.fugu_channel_name,
                "tags": $scope.orderDetails.fugu_tags,
                "transaction_id": $scope.orderDetails.fugu_channel_id
            }


            fuguInit({
                "appSecretKey": fuguKey ,
                callback: function () {
                    window.startConversation(a);
                }
            });
        }

        var timer;
        var first = 1;
        $scope.orderStatus = function() {
            if(first){
                $rootScope.loading_custom = true;
            }
            if($routeParams.product_type == 7) {

                API.post(fatafat_base_url2 + "order_history", {
                    "access_token": localStorage.getItem("accessToken"),
                    "order_id": $routeParams.order_id,
                    "product_type": $routeParams.product_type,
                    "client_id": "MEgLeJgyr1gwfv1D",
                    "integrated": 1
                }).then(function (result) {
                    if (result.data.flag == 143) {
                        $scope.orderDetails = result.data.order_history[0];
                        $scope.status = result.data.recent_orders_possible_fatafat_status
                        $scope.orderDetails.created_at = moment($scope.orderDetails.created_at).format('D MMMM YYYY, h:mm a');
                        $scope.orderDetails.delivery_time = $scope.orderDetails.is_immediate ? "ASAP" : moment.utc($scope.orderDetails.delivery_time).format('D MMMM YYYY, h:mm a');
                        console.log($scope.orderDetails);
                        $rootScope.loading_custom =  false;
                        first = 0;

                    }
                    else {

                    }
                });
            }
            else if($routeParams.product_type == 1) {

                API.post(rides_baseUrl2 + "get_ride_summary", {
                    "access_token": localStorage.getItem("accessToken"),
                    "engagement_id": $routeParams.order_id,
                    "product_type": $routeParams.product_type,
                    "device_type": 0,
                    "app_version":364,
                    "login_type":0
                }).then(function (result) {
                    $scope.orderDetails = result.data;
                    $scope.orderDetails.product_type = $routeParams.product_type;
                    console.log(result.data)
                    $rootScope.loading_custom = false;
                    first = 0;
                });

            }

            else if ($routeParams.product_type == 2 || $routeParams.product_type == 3) {

                API.post(fatafat_base_url + "v2/order_history", {
                    "access_token": localStorage.getItem("accessToken"),
                    "order_id": $routeParams.order_id,
                    "product_type": $routeParams.product_type,
                    "device_type": 0,
                    "app_version":364,
                    "client_id": "MEgLeJgyr1gwfv1D",
                    "integrated": 1
                }).then(function (result) {
                    if (result.data.flag == 173) {
                        $scope.orderDetails = result.data.data[0];
                        console.log($scope.orderDetails);
                        $scope.status = result.data.recent_orders_possible_status;
                        $scope.orderDetails.created_at = moment($scope.orderDetails.created_at).format('D MMMM YYYY, h:mm a');
                        $scope.orderDetails.delivery_time = $scope.orderDetails.is_immediate ? "ASAP" : moment.utc($scope.orderDetails.delivery_time).format('D MMMM YYYY, h:mm a');
                        console.log($scope.orderDetails);
                        $rootScope.loading_custom = false;
                        first = 0;

                    }

                });

            }

            else if ($routeParams.product_type == 5 || $routeParams.product_type == 9) {

                API.post(menu_base_url + "v2/order_history", {
                    "access_token": localStorage.getItem("accessToken"),
                    "order_id": $routeParams.order_id,
                    "product_type": $routeParams.product_type,
                    "device_type": 0,
                    "app_version":364,
                    "client_id": "MEgLeJgyr1gwfv1D",
                    "integrated": 1
                }).then(function (result) {
                    if (result.data.flag == 173) {
                        $scope.orderDetails = result.data.data[0];
                        console.log($scope.orderDetails);
                        $scope.status = result.data.recent_orders_possible_status;
                        $scope.orderDetails.created_at = moment($scope.orderDetails.created_at).format('D MMMM YYYY, h:mm a');
                        $scope.orderDetails.delivery_time = $scope.orderDetails.is_immediate ? "ASAP" : moment.utc($scope.orderDetails.delivery_time).format('D MMMM YYYY, h:mm a');
                        console.log($scope.orderDetails);
                        $rootScope.loading_custom = false;
                        first = 0;

                    }

                });

            }

            timer = $timeout(function () {
                $scope.orderStatus();
            }, 15000);


        };

        $scope.orderStatus();



        $scope.$on("$destroy", function() {

                if (angular.isDefined(timer)) {
                    $timeout.cancel(timer);
                    timer = undefined;
                }
            }
        );

    }])


